import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Pebble from "./pages/Pebble";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CostingPage from "./user_initiated/CostingPage";
import MedicationPaymentCallback from "./user_initiated/MedicationPaymentCallback";
import ConsultationPaymentCallback from "./user_initiated/ConsultationPaymentCallback";
import Paystack from "./user_initiated/Paystack";
import PaymentFailed from "./user_initiated/PaymentFailed";
import CallEntryPage from "./user_initiated/CallEntryPage";
import ReferralDecisionPage from "./user_initiated/ReferralDecisionPage";
import ReviewPage from "./user_initiated/ReviewPage";
import NotFound from "./pages/NotFound";
import Video from "./pages/Video";
import DeveloperHome from "./pages/developer/DeveloperHome";
import WidgetConfig from "./pages/developer/WidgetDoc";
import ReferralSystemPage from "./pages/referral-system";
import FreePlanAnimation from "./pages/FreePlan";
import HomeTests from "./pages/HomeTests";
import HomeTestOrders from "./pages/HomeTestOrders";
import HomeTestTracking from "./pages/HomeTestTracking";
import ArticlesIndex from "./pages/articles/ArticlesIndex";
import ArticleDetail from "./pages/articles/ArticleDetail";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/pebble" element={<Pebble />} />
        <Route path="/pebbles" element={<Pebble />} />
        <Route path="/kits" element={<HomeTests />} />
        <Route path="/video" element={<Video />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/developer" element={<DeveloperHome />} />
        <Route path="/developer/widget-config" element={<WidgetConfig />} />
        <Route path="/referral-system" element={<ReferralSystemPage />} />
        <Route path="/free-plan" element={<FreePlanAnimation />} />
        <Route path="/home-test" element={<HomeTests />} />
        <Route path="/home-tests" element={<HomeTests />} />
        <Route path="/home-testing-kit" element={<HomeTests />} />
        <Route path="/orders" element={<HomeTestOrders />} />
        <Route path="/orders/:orderId" element={<HomeTestTracking />} />
        <Route path="/articles" element={<ArticlesIndex />} />
        <Route path="/articles/:slug" element={<ArticleDetail />} />

        {/* routes for users */}
        <Route path="/cost-medication/:requestId" element={<CostingPage />} />
        <Route
          path="/medication-payment/callback"
          element={<MedicationPaymentCallback />}
        />
        <Route
          path="/pay-per-consultation/callback"
          element={<ConsultationPaymentCallback />}
        />
        <Route path="/vp  " element={<Paystack />} />
        <Route path="/payment-failed/:clientId" element={<PaymentFailed />} />
        <Route path="/call/:shortId" element={<CallEntryPage />} />
        <Route path="/referrals/:id" element={<ReferralDecisionPage />} />
        <Route path="/review/:patientId" element={<ReviewPage />} />
      </Routes>
    </Router>
  );
}

export default App;
